import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-1 text-center" }
const _hoisted_2 = { class: "text-3xl font-gotham-bold text-brand-secondary" }
const _hoisted_3 = { class: "mt-0 lg:mt-4" }
const _hoisted_4 = { class: "flex justify-center text-center items-center text-gray-700" }
const _hoisted_5 = { class: "leading-7" }
const _hoisted_6 = {
  key: 0,
  class: "mb-1 tracking-tight font-extrabold text-4xl"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 text-xl font-gotham-bold" }, "/Month", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center my-2 px-2.5 py-0.5 rounded-full text-md font-gotham-medium bg-brand-secondary text-white" }, "Unlimited Data!")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "my-1 lg:my-1 text-gray-700 font-gotham-bold"
}
const _hoisted_10 = { class: "font-gotham-bold text-gray-700" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("typical evening speed")
const _hoisted_14 = {
  role: "list",
  class: "mt-2 mb-2 space-y-2 hidden lg:block font-gotham-medium"
}
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "ml-3 pt-1 text-gray-700 text-left" }
const _hoisted_17 = { class: "ml-3 pt-1 text-gray-700" }
const _hoisted_18 = { class: "ml-3 pt-1 text-gray-700" }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 1,
  class: "bg-brand-button font-gotham-bold text-brand-button-text px-8 py-2 rounded-full mx-6 lg:mx-10 mt-3",
  onclick: "javascript:document.getElementById('primary-address-search').focus()"
}

import { CheckIcon } from '@heroicons/vue/outline';
import { computed, ref } from 'vue';
import { BrandServiceInterface, PlanSelectorProductInformation } from '@/services/brand/brandServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';

type Product = {
  id: string,
  name: string,
  description: string,
  download: number | null,
  upload: number | null,
  typicalEveningSpeed: number | null,
  price: number,
  discountedPrice?: number,
  discounted?: boolean,
  displayDiscount?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    canSelectProduct: { type: Boolean, required: true },
    isSelectedProduct: { type: Boolean, required: true },
    product: { type: Object, required: true },
    planSelectorProductInformation: { type: null, required: true }
  },
  emits: ["onPlanSelected"],
  setup(__props: any, { emit }: { emit: ({(event: 'onPlanSelected', id: string): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  canSelectProduct: boolean,
  isSelectedProduct: boolean,
  product: Product,
  planSelectorProductInformation: PlanSelectorProductInformation
}
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');





const mostPopular = computed(() => {
  return props.product.download === 250
    ? 'text-white hover:bg-brand-primary'
    : 'text-white hover:bg-brand-primary';
});

const standardFeatures = ref(props.planSelectorProductInformation.standardFeatures).value;
const standardLinks = ref(props.planSelectorProductInformation.standardLinks).value;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onPlanSelected', __props.product.id))),
    class: _normalizeClass(["my-2 lg:my-0 transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col lg:w-1/4", { 'border-black border': __props.isSelectedProduct, 'border border-gray-200': !__props.isSelectedProduct, 'cursor-pointer': __props.canSelectProduct }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.product.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(['tracking-tight font-gotham-bold', __props.product.displayDiscount ? 'text-2xl text-gray-700 text-decoration-line: line-through' : 'text-5xl font-extrabold'])
            }, "$" + _toDisplayString(__props.product.price), 3),
            (__props.product.displayDiscount)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "$" + _toDisplayString(__props.product.discountedPrice), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ])
      ]),
      _hoisted_8,
      (__props.product.typicalEveningSpeed)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(__props.product.typicalEveningSpeed) + " Mbps", 1),
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_14, [
        _createElementVNode("li", _hoisted_15, [
          _createVNode(_unref(CheckIcon), {
            class: "flex-shrink-0 w-8 h-8 text-brand-secondary-accent",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_16, _toDisplayString(__props.product.description), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardFeatures), (standardFeature) => {
          return (_openBlock(), _createElementBlock("li", {
            key: standardFeature,
            class: "flex"
          }, [
            _createVNode(_unref(CheckIcon), {
              class: "flex-shrink-0 w-8 h-8 text-brand-secondary-accent",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_17, _toDisplayString(standardFeature), 1)
          ]))
        }), 128)),
        (_openBlock(), _createElementBlock("li", {
          key: __props.product.name,
          class: "flex text-left"
        }, [
          _createVNode(_unref(CheckIcon), {
            class: "flex-shrink-0 w-8 h-8 text-brand-secondary-accent",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_18, _toDisplayString(__props.product.download) + " / " + _toDisplayString(__props.product.upload) + " (Mbps download/upload) ", 1)
        ]))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardLinks), (standardLink) => {
        return (_openBlock(), _createElementBlock("a", {
          key: standardLink.name,
          href: standardLink.link,
          target: "_blank",
          class: "block href font-gotham-bold text-brand-primary hover:text-blue-800 hover:underline underline transition duration-250 my-1"
        }, _toDisplayString(standardLink.name), 9, _hoisted_19))
      }), 128))
    ]),
    (__props.canSelectProduct)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["transition duration-250", [_unref(mostPopular), 'mt-0 lg:mt-8 block w-full py-3 px-6 border border-transparent rounded-md  hover:text-white text-center font-medium text-brand-button-text', __props.isSelectedProduct ? 'bg-brand-button' : 'bg-brand-primary-light']])
        }, _toDisplayString(__props.isSelectedProduct ? 'Selected' : 'Select Plan'), 3))
      : (_openBlock(), _createElementBlock("button", _hoisted_20, "Check Address"))
  ], 2))
}
}

})